import React from "react";
import { observer } from "mobx-react";
import Calendar from 'react-calendar';
import Layout from "../../components/Layout";
import  moment from 'moment';
import 'moment/locale/ko';
import {withStyles} from '@material-ui/core/styles';
import { withAlert } from "react-alert";
import user from "../../stores/userStore";
import {Button } from '@material-ui/core';
import { toJS } from "mobx";
import '../../styles/Calendar.css';
import '../../styles/table.css';
import '../../styles/total.css';
import attendance1 from '../../stores/attendanceStore';
import swal from "sweetalert2";
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';

const styles = (theme) => ({
    tableContainer: {
      marginTop: 20,
    },
    calen: {
        height:'100%',
        width:'100%',
    },
    hidden: {
      display: 'none',
    },
  });
  const View = observer(
    
    class attendance extends React.Component  {
        constructor(props){
            super(props);
            this.state = {
                dDay: moment().format('MM/DD'),
                dDays: moment().format('YYYY/MM/DD'),
                nowTime: moment().format('HH:mm:ss'),
                date: moment().add(1,'s').format('HH:mm:ss'),
                cDate: new Date(),
                bDisplay: 'none',
                inDisabled: false,
                outDisabled: true,
                disabled: false,
                autoChk: false,
                autoBtn: '',
                autoColor: '',
                open:false,
                yymm: moment().format('YYYY/MM'),
                btnName: '',
                btnId: '',
                nameDisable: false,
            }
        }
        
        componentWillUnmount(){
            clearInterval(this.timerId);
        }

        tick(){
            this.setState({
                date: moment().add(1,'s').format('HH:mm:ss')
            });
        }

        handleChange = (e) => {
          this.setState({
            [e.target.name]: e.target.value,
          });
        };

        componentDidMount = async () => {
            await user.getUserList();
            await attendance1.getList();
            this.timerId = setInterval(
              () => this.tick(),1000);
        }

        handleAutoAttClick = async(userid, lName, chk) =>{
          console.log("chk : " + chk);
          var nowDate = moment().format("YYYY/MM/DD");
          const attList = toJS(attendance1).list;
          const llist = attList.find((e)=>{
            if(moment(e.inTime).format("YYYY/MM/DD") === nowDate){
              if(e.lName === lName && e.userid === userid){
                return moment(e.inTime).format();
              }
            }else{
              return null;
            }
          });
          if(chk == false){
            const a = swal.fire({
              text : '자동 출근 처리하시겠습니까?',
              icon : 'question',
              showCancelButton: true,
              confirmButtonText: "예",
              cancelButtonText: "아니오",
              allowEnterKey : true,
            }).then(async (result)=>{
              if(result.isConfirmed){
                chk = 'Y';
                if(llist == null){
                  try{
                    await user.updateAutoChk(userid, lName, chk);
                    await attendance1.addAttendance(userid, lName, nowDate);
                    swal.fire({
                      text : '출근 처리되었습니다.',
                      icon : 'success',
                      confirmButtonText: "확인",
                    });
                  }catch{
                  }
                }else{
                  await user.updateAutoChk(userid, lName, chk);
                  swal.fire({
                    text : '자동 출근 체크되었습니다.',
                    icon : 'success',
                    confirmButtonText: "확인",
                  })
                }
              }
            });
          }else{
            const a = swal.fire({
              text : '자동 출근 해제하시겠습니까?',
              icon : 'question',
              showCancelButton: true,
              confirmButtonText: "예",
              cancelButtonText: "아니오",
            }).then(async (result)=>{
              if(result.isConfirmed){
                chk = 'N';
                try{
                  await user.updateAutoChk(userid, lName, chk);
                  swal.fire({
                    text : '자동 출근 해제되었습니다.',
                    icon : 'success',
                    confirmButtonText: "확인",
                  })
                }catch{
                }
              }
            })
          }
        }

        handleAttClick = async(userid, lName) =>{
          var nowDate = moment().format("YYYY/MM/DD");
          
          const attList = toJS(attendance1).list;
          const llist = attList.find((e)=>{
            if(moment(e.inTime).format("YYYY/MM/DD") === nowDate){
              if(e.lName === lName && e.userid === userid){
                return moment(e.inTime).format();
              }
            }else{
              return null;
            }
          });
          if(llist == null){
            try{
              await attendance1.addAttendance(userid, lName, nowDate);
              swal.fire({
                text : '출근 처리되었습니다.',
                icon : 'success',
                confirmButtonText: "확인",
                allowEnterKey : true,
              });
            }catch{
            }
          }
         }

        handleAttOutClick = async(userid, lName, nullTime) =>{
          var nowDate = moment().format("YYYY/MM/DD");
          const attList = toJS(attendance1).list;
          const llist = attList.find((e)=>{
            if(moment(e.inTime).format("YYYY/MM/DD") === nowDate){
              if(e.lName === lName && e.userid === userid){
                return moment(e.inTime).format();
              }
            }else{
              return null;
            }
          });

          if(llist != null){
            this.setState({disabled : true})
            await attendance1.upAttendance(userid, lName, llist, nullTime);
            swal.fire({
              text : '퇴근 처리되었습니다.',
              icon : 'success',
              confirmButtonText: "확인",
              allowEnterKey : true,
            });
            this.setState({disabled : false})
            this.setState({dDay: moment().format("MM/DD")})
            this.setState({dDays: moment().format("YYYY/MM/DD")})
          }
        }

        onChange = (cDate) =>{
          var nowDate = moment();

          var result = moment.duration(nowDate.diff(cDate)).asDays();
          if(result < 0){
            this.setState({dDay: moment().format("MM/DD")})
            this.setState({dDays: moment().format("YYYY/MM/DD")})
            swal.fire({ 
              text : '오늘 이후 날짜는 확인하실 수 없습니다.',
              icon : 'error',
              confirmButtonText: "확인",
              allowEnterKey : true,
            }).then(()=>{
              this.setState({selectedDate: moment()});
            });
            
          }else{
            this.setState({selectedDate: cDate});
            this.setState({dDay: moment(cDate).format("MM/DD")});
            this.setState({dDays: moment(cDate).format("YYYY/MM/DD")});
          }
        }

        todayChange = () =>{
          if(this.state.dDay == moment().format("MM/DD")){
            swal.fire({
              text : '오늘 날짜입니다.',
              icon : 'error',
            })
            this.setState({selectedDate: moment()});
          }else{
            this.setState({dDay: moment().format("MM/DD")});
            this.setState({dDays: moment().format("YYYY/MM/DD")});
            this.setState({selectedDate: moment()});
          }
        }

        modalPopupOpen = (userid, name) =>{
          this.state.btnName = name;
          this.state.btnId = userid;
          this.setState({open: true})
          this.setState({nameDisable:true});
        }
        modalPopupClose = (name) =>{
          this.setState({open: false});
          this.setState({yymm: moment().format('YYYY/MM')});
          this.setState({nameDisable: false});
        }

        monthChange = (value) =>{
          var i = this.state.yymm;
          var year = moment(i).format('YYYY');
          var dataVal = year + '/' + value;
          this.setState({yymm: moment(dataVal).format('YYYY/MM')});
          
        }

        prevChange = (yymm) =>{
          var year = moment(yymm).format('YYYY');
          var month = moment(yymm).format('MM');
          var dateVal = '';
          if(parseInt(month) == 1){
            year = parseInt(year) - 1;
            month = 12;
            dateVal = year+'/'+month;
            this.setState({yymm: moment(dateVal).format('YYYY/MM')});
          }else{
            month = parseInt(month) - 1;
            dateVal = year+'/'+month;
            this.setState({yymm: moment(dateVal).format('YYYY/MM')});
          }

        }
        nextChange = (yymm) =>{
          var year = moment(yymm).format('YYYY');
          var month = moment(yymm).format('MM');
          var dateVal = '';
         
          if(parseInt(month) == 12){
            year = parseInt(year) + 1;
            month = 1;
            dateVal = year+'/'+month;
            this.setState({yymm: moment(dateVal).format('YYYY/MM')});
          }else{
            month = parseInt(month) + 1;
            dateVal = year+'/'+month;
            this.setState({yymm: moment(dateVal).format('YYYY/MM')});
          }
        }
        
        render(){
            
            const calen = {
                width:'80%',
            }
            const dialogCss = {
              position:'absolute',
            }
            const cardBCss = {
              padding:'0 0 0 2%',
            }
            const attendanceBack = {
              backgroundColor:'c5d3f6',
            }
            
            const groups = toJS(user).userList;
            const lName = toJS(user).user.username;
            const userId = toJS(user).user.userid;
            
            const attList = toJS(attendance1.list);
            var nullTime = '';
            const users = JSON.stringify(groups);
            attList.sort(function (a, b) {
              var a = new Date(a.inTime).getTime();
              var b = new Date(b.inTime).getTime();
               return a > b ? 1 : -1;
            });
            
            
            
            
            
            const btnAttList = attList.map((e)=>{
              var name = this.state.btnName;
              var id = this.state.btnId;
              var day = this.state.yymm;
              var inTime = e.inTime;
              if(name === e.lName){
                if(id === e.userid){
                  if(moment(day).format('YY/MM') === moment(inTime).format('YY/MM')){
                    if(e.outTime == '' || e.outTime == null){
                      e.outTime = '';
                    }else{
                      var outTime = moment(e.outTime).format('HH:mm:ss');
                    }
                    return <tr>
                          <td class='monthBtnTd'>{moment(e.inTime).format('YYYY/MM/DD(ddd)')}</td>
                          <td class='monthBtnTd'>{moment(e.inTime).format('HH:mm:ss')}</td>
                          <td class='monthBtnTd'>{outTime}</td>
                        </tr>
                  }
                }
              }
            })

            groups.sort(function (a, b) {
              return a.username < b.username ? -1 : a.username > b.username ? 1 : 0;
            });
            
            groups.map((e)=>{
              if(lName === e.username){
                if(e.autoChk == 'N' || e.autoChk == null || e.autoChk == ''){
                  this.state.autoChk = false;
                  this.state.autoBtn = "자동출근";
                  this.state.autoColor = "primary";
                }else{
                  this.state.autoChk = true;
                  this.state.autoBtn = "자동출근해제";
                  this.state.autoColor = "secondary";
                }
              }
            })

            const nameBtn = groups.map((e)=>{
              return <button class='nameBtn' onClick={()=> this.modalPopupOpen(e.userid, e.username)}>{e.username}</button>;
            })

            const userIn = groups.map((e)=>{
              var nowDate = moment().format("YYYY/MM/DD");
              var yetDate = moment(this.state.dDays).format("YYYY/MM/DD");
              if(nowDate == yetDate){
                attList.map((e1)=>{
                  var searchDate = moment(e1.inTime).format("YYYY/MM/DD");
                  if(nowDate === searchDate){
                    if(e1.lName === e.username){
                      if(e1.userid === e.userid){
                        e.inTime = e1.inTime
                        if(e1.lName === lName){
                          this.state.inDisabled = true;
                          this.state.outDisabled = false;
                        }
                      }
                    }
                  }
                })
                return <tr class='timeTr'><td colspan='2' class='nameTd'>{e.username} : </td>
                <td colspan='3' class='timeTd'>{e.inTime&&moment(e.inTime).format("HH:mm:ss")}</td></tr>;

              }else{
                attList.map((f)=>{
                  var searchDate = moment(f.inTime).format("YYYY/MM/DD");
                  if(yetDate === searchDate){
                    if(f.lName === e.username){
                      if(f.userid === e.userid){
                        e.inTime = f.inTime
                      }
                    }
                  }
                })
                return <tr class='timeTr'><td colspan='2' class='nameTd'>{e.username} : </td>
                <td colspan='3' class='timeTd'>{e.inTime&&moment(e.inTime).format("HH:mm:ss")}</td></tr>;
              }
            });

            const monthArr = [
              {index : 1, value : '01'},
              {index : 2, value : '02'},
              {index : 3, value : '03'},
              {index : 4, value : '04'},
              {index : 5, value : '05'},
              {index : 6, value : '06'},
              {index : 7, value : '07'},
              {index : 8, value : '08'},
              {index : 9, value : '09'},
              {index : 10, value : '10'},
              {index : 11, value : '11'},
              {index : 12, value : '12'},
            ];

            const monthName = monthArr.map((e)=>{
              return <button class='monthBtn' disabled={this.state.btnChk} onClick={()=> this.monthChange(e.value)}>{e.index}월</button>;
            })

            const userOut = groups.map((e)=>{
              var nowDate = moment().format("YYYY/MM/DD");
              var yetDate = moment(this.state.dDays).format("YYYY/MM/DD");
              if(nowDate == yetDate){
                attList.map((e1)=>{
                  var searchDate = moment(e1.inTime).format("YYYY/MM/DD");
                  if(nowDate === searchDate){
                    if(e1.lName === e.username){
                      if(e1.userid === e.userid){
                        e.outTime = e1.outTime
                      }
                    }
                  }
                })
                return <tr class='timeTr'><td colspan='2' class='nameTd'>{e.username} : </td>
                <td colspan='3' class='timeTd'>{e.outTime&&moment(e.outTime).format("HH:mm:ss")}</td></tr>;
              }else{
                attList.map((f)=>{
                  var searchDate = moment(f.inTime).format("YYYY/MM/DD");
                  if(yetDate === searchDate){
                    if(f.lName === e.username){
                      if(f.userid === e.userid){
                        e.outTime = f.outTime
                      }
                    }
                  }
                })
                return <tr class='timeTr'><td colspan='2' class='nameTd'>{e.username} : </td>
                <td colspan='3' class='timeTd'>{e.outTime&&moment(e.outTime).format("HH:mm:ss")}</td></tr>;
              }
            });
            
            return(
                <Layout>
                  <Dialog open={this.state.open} onClose={this.modalPopupClose} class='dialog' style={dialogCss}>
                    <DialogTitle>
                      <div class='diaTDiv'>
                        <input type='button' class='beafBtn' value= "<" onClick={()=> this.prevChange(this.state.yymm)}/>
                        <span class='yymm'>{this.state.yymm}</span>
                        <input type='button' class='beafBtn' value= ">" onClick={()=> this.nextChange(this.state.yymm)}/>
                      </div>
                      <div class='diaTDiv'>{monthName}</div>
                    </DialogTitle>
                                
                    <DialogContent>
                    <table class='monthBtnTable'>
                    <tr>
                      <th>년/월/일</th>
                      <th>출근시간</th>
                      <th>퇴근시간</th>
                    </tr>
                    </table>  
                    </DialogContent>
                    <DialogContent class='dateList'>
                    <table class='monthBtnTable'>
                      {btnAttList}

                    </table>
                    </DialogContent>
                    <DialogActions><button onClick={() => this.modalPopupClose()} class='diaCancelBtn'>닫기</button></DialogActions>
                  </Dialog>
                  
                <div className="attendance" style={attendanceBack}>
                    <div class='leftDiv'>
                      <div class="watchDiv">{this.state.date}</div>
                      <fieldset class='fs'>
                      <legend class='fieldLegend'><b>출퇴근 버튼</b></legend>
                      <div class="btnDiv">
                      <Button 
                          variant="contained" 
                          color={this.state.autoColor} 
                          onClick={() => this.handleAutoAttClick(userId, lName, this.state.autoChk)}>{this.state.autoBtn}</Button>&nbsp;
                      <Button 
                          variant="contained" 
                          color="primary" 
                          display={this.state.bDisplay}
                          disabled={this.state.inDisabled}
                          onClick={() => this.handleAttClick(userId, lName)}>출근</Button>&nbsp;
                      <Button 
                          variant="contained" 
                          color="primary" 
                          disabled={this.state.outDisabled}
                          onClick={() => this.handleAttOutClick(userId, lName, nullTime)}>퇴근</Button>&nbsp;
                        <Button 
                          variant="outlined" 
                          color="primary" 
                          disabled={this.state.disabled}
                          onClick={() => this.todayChange()}>오늘 출근부</Button></div>
                          </fieldset>

                          <fieldset class='fsMonth'>
                          <legend class='fieldMonthLegend'><b>월별 출근부</b></legend>
                          <div class='nameBtnDiv'>{nameBtn}</div>
                          </fieldset>

                      <div style={calen} class='calDiv'>
                          <Calendar 
                              value={this.state.cDate}
                              onClickDay={this.onChange}
                          />
                      </div>
                    </div>
                      
                    <div class='rightDiv'>
                      <div class='inDiv'>
                        <table class='table'>
                          <tr>
                            <th colspan='5' class='attHead'>{this.state.dDay + ' 출근시간'}</th>
                          </tr>
                          {userIn}
                        </table>
                      </div>
                      <div class='outDiv'>
                        <table class='table'>
                          <tr>
                            <th colspan='5' class='attHead'>{this.state.dDay + ' 퇴근시간'}</th>
                          </tr>
                          {userOut}
                        </table>
                      </div>
                    </div>
                </div>
                </Layout>
            )
        }
    }
  );
const alertView = withAlert()(View);
export default withStyles(styles)(alertView);